module.exports = __webpack_public_path__ + "img/wechatPay.fca4110f.png";